import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './OverlayTiles.css';
import { canUseDOM, get, injectImageResolution } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import ScrollAnimation from 'react-animate-on-scroll';
import RouterLink from '../atoms/RouterLink';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import LazyPicture from '../atoms/LazyPicture';
import React, { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';
import { convertToAnalyticObject } from '../../utils/analytics';
;
;
var OverlayTiles = function OverlayTiles(_ref) {
  var fields = _ref.fields,
    rendering = _ref.rendering,
    params = _ref.params;
  var cards = get(fields, 'data.item.tiles.items', []);
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    tileItemHeight = _useState2[0],
    settileItemHeight = _useState2[1];
  var uid = rendering.uid;
  var countHeights;
  if (canUseDOM) {
    countHeights = throttle(function () {
      var heights = Array.from(document.querySelectorAll(".overlay-tile-content-".concat(uid))).map(function (item) {
        return item.offsetHeight;
      });
      settileItemHeight({
        "min-height": "".concat(Math.max.apply(Math, _toConsumableArray(heights)), "px")
      });
    });
  }
  useEffect(function () {
    if (canUseDOM) {
      setTimeout(countHeights, 500);
      window.addEventListener('resize', countHeights);
    }
    return function () {
      window.removeEventListener('resize', countHeights);
    };
  }, []);
  useEffect(function () {
    setTimeout(countHeights, 500);
  }, [sitecoreContext.selectedFontSize]);
  var colClasses = {
    1: 'col-lg-12',
    2: 'col-lg-6',
    3: 'col-lg-4'
  };
  if (!fields.data.item) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  if (!fields) {
    console.info('OverlayTiles component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [OverlayTiles component is empty: please provide data source]");
    }
    return null;
  }
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var renderTiles = function renderTiles() {
    if (cards.length) {
      return cards.map(function (item, index) {
        var title = item.title.jss;
        var subtitle = item.subtitle.jss;
        var description = item.description.jss;
        var backgroundImage = item.backgroundImage.jss.value;
        var ctaLabel = item.ctaLabel.jss.value;
        var cTALink = item.cTALink.jss.value;
        var hasSubTitle = item.subtitle.jss.value;
        var hasDescription = item.backgroundImage.jss.value.src;
        return /*#__PURE__*/React.createElement("div", {
          key: title.value,
          style: {
            padding: 0
          },
          className: "overlay-tile col-xs-12 col-md-12 ".concat(colClasses["".concat(cards.length)], " ").concat(rtl ? overlayTileRtl : overlayTileLtr)
        }, /*#__PURE__*/React.createElement("div", {
          className: "overlay-tile-content-wrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "overlay-tile-content overlay-tile-content-".concat(uid),
          style: tileItemHeight
        }, /*#__PURE__*/React.createElement("div", {
          className: "overlay-tile-text--container"
        }, hasSubTitle ? /*#__PURE__*/React.createElement(ScrollAnimation, {
          animateIn: "animate__fadeInUp",
          animateOnce: true,
          duration: 1
        }, /*#__PURE__*/React.createElement(Text, {
          tag: "h5",
          className: 'overlay-tiles-subtitle',
          field: subtitle
        })) : null, /*#__PURE__*/React.createElement(ScrollAnimation, {
          animateIn: "animate__fadeInUp",
          animateOnce: true,
          duration: 1
        }, /*#__PURE__*/React.createElement(Text, {
          tag: "h2",
          className: 'overlay-tiles-title',
          field: title
        })), /*#__PURE__*/React.createElement("div", {
          className: "overlay-tiles-description--wrapper"
        }, hasDescription ? /*#__PURE__*/React.createElement(ScrollAnimation, {
          animateIn: "animate__fadeInUp",
          animateOnce: true,
          duration: 1
        }, /*#__PURE__*/React.createElement(Text, {
          tag: "p",
          className: 'overlay-tiles-description',
          field: description
        })) : null)), /*#__PURE__*/React.createElement("div", {
          className: "overlay-tiles-btn--wrapper"
        }, /*#__PURE__*/React.createElement(ScrollAnimation, {
          animateIn: "animate__fadeInUp",
          animateOnce: true,
          duration: 1
        }, /*#__PURE__*/React.createElement(RouterLink, {
          className: "overlay-tiles-button btn general-card-button",
          href: cTALink.href,
          title: "".concat(ctaLabel),
          linktype: cTALink.linktype,
          linksTarget: cTALink.target,
          onClick: function onClick() {
            return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["buttonAnalytics"], params), [title.value, ctaLabel]);
          }
        }, ctaLabel)))), /*#__PURE__*/React.createElement(LazyPicture, {
          className: 'overlay-tile-image'
        }, /*#__PURE__*/React.createElement("source", {
          media: "(min-width: 768px)",
          srcSet: "".concat(injectImageResolution(backgroundImage.src, 1650, 928))
        }), /*#__PURE__*/React.createElement("img", {
          src: "".concat(injectImageResolution(backgroundImage.src, 768, 432)),
          alt: backgroundImage.alt
        }))));
      });
    } else {
      return /*#__PURE__*/React.createElement("div", null);
    }
  };
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    fullWidth: true,
    className: commonStyles,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: 'overlay-tiles-container'
  }, renderTiles()));
};
var commonStyles = "corpcpx";
var overlayTileRtl = "o1ilmsk";
var overlayTileLtr = "o1wmvxcn";
export default OverlayTiles;